module.exports = __webpack_public_path__ + "img/얼굴_실패.ad6dc3c4.svg";